import { NAME_SPACE } from './config';
import AccordionSlot from './AccordionSlotComponent.vue';

export default {
    name: NAME_SPACE,
    components: {
        'accordion-slot-component': AccordionSlot,
    },
};
